import { Injectable } from '@angular/core';
import { SessionStorageService } from '../sessionStorageService/session-storage.service';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(public lsService: SessionStorageService) { }

  getToken(): string | null {
    return this.lsService.getLSItem('Auth');
  }

}